import firebase from 'firebase'
import { firebaseConfig } from './config'

export const firebaseApp = firebase.initializeApp(firebaseConfig)
export const firebaseDb = firebaseApp.database()
export const firebaseAuth = firebase.auth




// WEBPACK FOOTER //
// ./src/lib/firebase/index.js